<template>
  <div class="field">
    <label
      class="label"
      v-html="label"
    />
    <p class="control">
      <textarea
        :value="modelValue.value"
        class="textarea"
        :placeholder="placeholder"
        @input="handleInput"
      />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: 'Enter text here',
      type: String,
    },
    modelValue: {
      default() {
        return { value: '', ok: true };
      },
      type: Object,
    },
    placeholder: {
      default: '',
      type: String,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    handleInput(event) {
      const { value } = event.target;
      this.$emit('update:modelValue', {
        value,
        ok: true,
      });
    },
  },
};
</script>
